import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../../../../ApiService";
import { useUser } from "../../../pages/authentification/UserContext";
import { API_ENDPOINTS } from "../../../../ApiService";
import { storeUserData } from "../../../services/security";
import { styled } from "@mui/material/styles";
import { setAuthToken } from "../../../../ApiService";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import backgroundImage from "../../../components/images/login/Login.jpg";

// Create a full-screen background with a blur effect.
const Background = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "#0F172A",
  backgroundImage: `
    radial-gradient(circle, rgba(255,255,255,0.05) 1px, transparent 1px),
    linear-gradient(135deg, rgba(255,255,255,0.02) 50%, transparent 50%)`,
  backgroundSize: "8px 8px, 100% 100%",
  zIndex: -1,
}));

// Create a styled card with rounded edges, semi-transparent background,
// and responsive sizing using breakpoints.
const Card = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[3],
  backgroundColor: "rgba(255, 255, 255, 0.85)",
  width: "100%",
  maxWidth: 320, // less wide on smaller screens
  minHeight: 400, // taller card on smaller screens
  [theme.breakpoints.up("md")]: {
    maxWidth: 400, // a bit wider on desktop
    minHeight: 400, // increased height on desktop
  },
}));

const Section = styled("section")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  backgroundColor: "transparent",
});

const LoginForm = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    //console.log("🔑 Attempting login with:", formData);
    try {
      const response = await apiService.post(API_ENDPOINTS.LOGIN, formData);

      if (response.status === 200) {
        const { token, refreshToken, roles, id, hasCompletedForm } =
          response.data;
        console.log("🔑 Login response data:", response.data);

        if (!token) {
          alert("Incorrect credentials. Please try again.");
          return;
        }

        // Build the userData object. (Even though storeUserData will now check for data.role, you can still pass your processed object.)
        const userData = {
          token,
          refreshToken,
          role: roles && roles.length > 0 ? roles[0] : "ROLE_USER",
          id,
          hasCompletedForm,
        };

        // Save user data in context and localStorage using our helper
        setUser(userData);
        storeUserData(userData); // This writes the complete object under "fitnesscoachingapp"
        setAuthToken(token); // Set Axios default header

        // Redirect based on role and form completion status.
        if (userData.role === "ROLE_ADMIN") {
          navigate("/clients");
        } else if (userData.role === "ROLE_USER") {
          navigate(hasCompletedForm ? `/dashboard/${id}` : "/debutformulaire");
        } else {
          alert("Unauthorized role. Please contact support.");
        }

        return response.data;
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Login failed. Please check your credentials and try again.");
    }
  };

  return (
    <Section>
      <CssBaseline />
      <Background />
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid item xs={10} sm={8} md={5}>
          <Card>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center", // centers content vertically
                height: "100%",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "#1976d2" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Sign in
              </Typography>
              <Box
                component="form"
                onSubmit={handleLogin}
                sx={{ mt: 1, width: "100%" }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="username"
                  label="Username"
                  name="username"
                  autoComplete="username"
                  autoFocus
                  value={formData.username}
                  onChange={(e) =>
                    setFormData({ ...formData, username: e.target.value })
                  }
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  disabled={loading}
                >
                  {loading ? "Signing in..." : "Sign In"}
                </Button>
              </Box>
            </Box>
          </Card>
        </Grid>
      </Box>
    </Section>
  );
};

export default LoginForm;
